module.exports = __webpack_public_path__ + "static/media/TermsConditions@3x.38fc445e.png";